import { render } from "./RentalPlaceList.vue?vue&type=template&id=53b40097&scoped=true"
import script from "./RentalPlaceList.vue?vue&type=script&lang=js"
export * from "./RentalPlaceList.vue?vue&type=script&lang=js"

import "./RentalPlaceList.vue?vue&type=style&index=0&id=53b40097&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b40097"]])

export default __exports__